import { DiscountType, InventoryItemStatus } from '@trnsact/trnsact-shared-types';
import { Attachment, EquipmentFormValue } from '../types';
import { equipmentStandardSingleInfoDefaultFormValues } from '../model';

// No type here: it depends on the vendor profile's industry group type, see getDefaultAttachmentType.
export const equipmentAttachment: Omit<Attachment, 'type'> = {
  model: '',
  unitCost: 0,
  category: 'Truck',
  manufacturer: '',
  quantityPerAsset: 1,
  discountValue: 0,
  retailPrice: 0,
  discountType: DiscountType.Flat,
};

export const formDefaultValue: EquipmentFormValue = {
  commonInfo: {
    vin: '',
    class: null,
    quantity: 1,
    mileage: null,
    hours: null,
    saleCost: 0,
    stockId: '',
    condition: '',
    description: '',
    retailPrice: 0,
    wholeSaleCost: 0,
    inventoryItem: {
      inventoryId: null,
      inventoryOption: null,
      status: InventoryItemStatus.Unknown,
    },
  },
  attachments: [],
  calcPricing: {
    retail: { total: 0, attachments: 0 },
    wholesale: { total: 0, attachments: 0 },
    customer: { total: 0, equipment: 0, attachments: 0 },
  },
  ...equipmentStandardSingleInfoDefaultFormValues,
};
